<template>
  <div class="container">
    <div class="home-banner">
      <img class="banner-bg" src="@/assets/news-bg.png" alt="">
      <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">最新资讯</p>
      </div>
    </div>
    <div class="news-box">
      <div class="news-cont">
        <div style="padding-bottom: 80px;"></div>
          <a v-for="(item,index) in new_list" :key="index" @click="go_single(item)">
            <div class="news-xinwen">
              <div class="news-img">
                <img :src="item.url" alt="">
              </div>
              <div class="news-tem">
                <div class="news-tem-title">
                  {{item.text}}
                </div>
                <div class="news-tem-date">
                  {{item.title}}
                </div>
                <div class="news-tem-text">
                </div>
              </div>
            </div>
          </a>
        <div style="padding-bottom: 60px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  data() {
    return {
      new_list: [{
        title: '2019-03-09',
        url: require('@/assets/热门配图-1-221x183.png'),
        text: '部盾科技CEO部瑞志博士与上海证券交易所联合课题项目成功通过验收',
        id: '1',
      },{
        title: '2018-10-10',
        url: require('@/assets/s-3.png'),
        text: '部盾科技CEO部瑞志博士与上海金融圈分享金融风险防范',
        id: '2',
      },{
        title: '2018-12-20',
        url: require('@/assets/image.png'),
        text: '部盾科技助力ATA发布《2018年ATA就业力报告》',
        id: '3',
      },{
        title: '2019-06-01',
        url: require('@/assets/热门图-133x183.jpg'),
        text: '部盾科技获得《税务研究》杂志征文优秀奖',
        id: '4',
      }]
    };
  },
  methods: {
    go_single(data) {
      this.$router.push({ path: '/NewsDetails', query: {id: data.id}})
    },
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>